module.exports = "/_next/static/images/Hero-10a34aa2f8017c47df4a9ce07049b644.webp";